import { render, staticRenderFns } from "./Lamp.vue?vue&type=template&id=0b40ccac&scoped=true&"
import script from "./Lamp.vue?vue&type=script&lang=js&"
export * from "./Lamp.vue?vue&type=script&lang=js&"
import style0 from "./Lamp.vue?vue&type=style&index=0&id=0b40ccac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40ccac",
  null
  
)

export default component.exports